'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchWebUtils = function () {
  function SearchWebUtils() {
    _classCallCheck(this, SearchWebUtils);
  }

  _createClass(SearchWebUtils, null, [{
    key: 'getLocale',
    value: function getLocale() {
      var locale = 'ja';
      if (window.APERZA && window.APERZA.locale) {
        locale = window.APERZA.locale;
        if (locale && locale.indexOf('_') > -1) {
          locale = locale.substring(0, locale.indexOf('_'));
        }
      }
      return locale;
    }
  }, {
    key: 'getDisabledLinks',
    value: function getDisabledLinks() {
      var disabledLinks = false;
      if (window.APERZA && window.APERZA.disabledLinks !== undefined) {
        disabledLinks = window.APERZA.disabledLinks;
      }
      return disabledLinks;
    }
  }, {
    key: 'getItemPageShown',
    value: function getItemPageShown() {
      var itemPageShown = false;
      if (window.APERZA && window.APERZA.itemPageShown !== undefined) {
        itemPageShown = window.APERZA.itemPageShown;
      }
      return itemPageShown;
    }
  }]);

  return SearchWebUtils;
}();

exports.default = SearchWebUtils;


//////////////////
// WEBPACK FOOTER
// ./~/@aperza/aperza-react-ui/lib/SearchWebUtils.js
// module id = 140
// module chunks = 0